import { mediaService } from '../services/mediaService';
import type { GallerySelectedImage } from '../components/shared/GallerySelectorModal';

/**
 * Converts a gallery image to a File object.
 * Uses the backend proxy (/download/images/{id}/proxy) to avoid S3 CORS issues.
 * Falls back to direct fetch if no backendId is available.
 */
export async function galleryImageToFile(
  image: GallerySelectedImage | undefined,
  url: string,
  filename = 'gallery-image.jpg'
): Promise<File> {
  let blob: Blob;

  if (image?.backendId) {
    blob = await mediaService.downloadMedia(image.backendId, 'image');
  } else {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch image: ${response.status}`);
    blob = await response.blob();
  }

  return new File([blob], filename, { type: blob.type || 'image/jpeg' });
}
